import React from "react";
import { StyleSheet, View } from "react-native";

import AppTheme from "../../../AppTheme";
import ComparisonHours from "./ComparisonHours";
import { getGoalProgressColor } from "../../../common/mood/MoodsHelper";
import { capitalize } from "lodash";

export default function ComparisonContentHours({
  totalMinutes,
  goalMinutes,
  goal = {},
}) {
  const progressColor = goal.mood
    ? getGoalProgressColor(goal)
    : AppTheme.almostBlack;

  return (
    <View style={styles.progressNumbers}>
      <ComparisonHours minutes={totalMinutes} label="Total" />
      {goalMinutes ? (
        <ComparisonHours
          minutes={goalMinutes}
          label={`Goal: ${capitalize(goal.operator)}`}
          suffix={" / " + goal.time_unit}
          style={{ color: progressColor }}
        />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  progressNumbers: {
    flexDirection: "row",
    alignItems: "center",
    borderTopColor: AppTheme.lightGray,
    borderTopWidth: 1,
    paddingTop: 8,
  },
});
